"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrLinksList = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const fdr_regular_basis_fdr_route_1 = require("@hotelplan/fdr.regular.basis.fdr-route");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const LinksListWrapper = styled_components_1.default.ul((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    columnGap: [3, 5],
    rowGap: [1, 0],
    borderTop: ['1px solid', 'none'],
    borderBottom: ['1px solid', 'none'],
    borderColor: 'borderColor',
    lineHeight: ['1', 'inherit'],
    alignItems: ['flex-start', 'center'],
    justifyContent: [null, 'flex-start'],
    px: [2, 0],
    py: [3, 0],
    marginBottom: [2, 0],
    width: ['100%', 'auto'],
    flexWrap: 'wrap',
    flexDirection: [null, 'row'],
    pr: [5, 0],
    marginLeft: [0, 'auto'],
    '@media (max-width: 1335px)': {
        marginLeft: 0,
        px: [2, 4],
        paddingBottom: 3,
        order: '-1',
        marginBottom: 2,
        width: '100%',
        borderBottom: '1px solid',
        borderColor: 'borderColor',
    },
}));
const ListItem = styled_components_1.default.li((0, util_theme_sxc_1.sx2CssThemeFn)({
    flex: ['0 0 47%', '0 0 auto'],
}));
const Link = (0, styled_components_1.default)(fdr_regular_basis_fdr_route_1.FdrRoute)((0, util_theme_sxc_1.sx2CssThemeFn)({
    fontSize: [1, 2],
}));
const FdrLinksList = ({ links, className = '', }) => {
    return (react_1.default.createElement(LinksListWrapper, { className: `links-list ${className}` }, links.map(({ link, caption }) => {
        return (react_1.default.createElement(ListItem, { key: caption, className: "list-item" },
            react_1.default.createElement(Link, { link: link },
                react_1.default.createElement("span", null, caption))));
    })));
};
exports.FdrLinksList = FdrLinksList;
//# sourceMappingURL=fdr-links-list.js.map